<template>
  <modal-layout :is-open="isOpen" @close="closeModal()">
    <div class="Modal_area Modal_wide">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="アンケートモーダルを閉じる"
        @click="closeModal()"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <div id="start-servey" ref="fv-container" class="fv-container">
          <div class="fv-title_outer">
            <p class="fv-title_en">
              Mindful Checker
            </p>
            <p class="fv-title_jp">
              今月のストレス値を
              <br>
              測ってみよう
            </p>
          </div>
          <div class="fv-contents_outer">
            <div class="fv-img">
              <img src="assets/img/mindful_checker/servey_img.png" alt="">
            </div>
            <div class="fv-contents_box">
              <div class="fv-contents_text_container">
                <p class="fv-content_text">
                  直感で回答して
                </p>
                <div class="fv-content_points">
                  <div class="fv-content_point-item">
                    <div class="point-icon">
                      <img src="assets/img/mindful_checker/list-icon.png" alt="">
                    </div>
                    <p class="fv-content_text">
                      ストレス値
                    </p>
                  </div>
                  <div class="fv-content_point-item">
                    <div class="point-icon">
                      <img src="assets/img/mindful_checker/list-icon.png" alt="">
                    </div>
                    <p class="fv-content_text">
                      おすすめクラス
                    </p>
                  </div>
                </div>
                <p class="fv-content_text">
                  を知ろう！
                </p>
                <p class="fv-content_text fv-content_text-last">
                  毎月1回は計測することがおすすめです！
                </p>
              </div>
              <router-link :to="'/mindful-survey' + ([5, 6].includes(userCategory) ? '/company' : '') + '?uuid=' + emailHash">
                <div class="btn_start-answer">
                  <p class="btn-text">
                    早速回答する
                  </p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import moment from 'moment'
import authService from '@/services/authService'

export default {
  name: 'ModalSurvey',
  components: { ModalLayout },
  data() {
    return {
      isOpen: false,
      closeTimes: 0
    }
  },
  computed: {
    ...mapState({
      emailHash: state => state.user.emailHash,
      userCategory: state => state.user.userInfo.ccategory
    })
  },
  mounted() {
    this.closeTimes = Cookies.get('melon_survey_close_times') || 0
    if (this.closeTimes > 1) return
    const lastClose = Cookies.get('melon_survey_modal_close_at')
    if (lastClose && (moment(lastClose, 'x').date() === moment().date())) {
      return
    }
    authService.getUserInfo().then((res) => {
      const lastSurveyAnswer = res.user.user.last_survey_answer
      if (!lastSurveyAnswer ||
        (moment(lastSurveyAnswer).month() !== moment().month() && moment().diff(moment(lastSurveyAnswer), 'days') > 7)) {
        this.isOpen = true
      }
    })
  },
  methods: {
    closeModal() {
      this.isOpen = false
      Cookies.set('melon_survey_modal_close_at', +moment(), { expires: moment().endOf('month').diff(moment(), 'days') })
      Cookies.set('melon_survey_close_times', +this.closeTimes + 1, { expires: moment().endOf('month').diff(moment(), 'days') })
    }
  }
}
</script>
<style>
@font-face {
  font-family: "Hiragino Kaku Gothic Pro";
  src: url(~@/assets/fonts/HiraKakuProN-W6.woff2);
}
</style>
<style scoped src="@/assets/css/modal_survey.css">
</style>
